import React from "react";

export const RichCurrentYear = (props: any) => {
    const year = new Date().getFullYear();
    const adjusted = props.add ? year + parseInt(props.add?.toString()?.replace(/[^\d]/g, '') || '0') : year;

    // console.log(year, props.add, parseInt(props.add), adjusted);
    return <>{ adjusted }</>;
}